import { Box, useTheme } from '@mui/material';
import { GridToolbarContainer, GridToolbarProps, useGridApiContext } from '@mui/x-data-grid-pro';

import { Icon } from '@verantos-dev/shared-components';

declare module '@mui/x-data-grid-pro' {
  interface ToolbarPropsOverrides {
    fileName: string;
  }
}

interface CustomToolbarProps extends GridToolbarProps {
  fileName: string;
}

export const DatagridExportToolbar = ({ fileName }: CustomToolbarProps) => {
  const theme = useTheme();
  const apiRef = useGridApiContext();

  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      fileName: fileName,
      escapeFormulas: false,
    });
  };

  return (
    <GridToolbarContainer>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          p: theme.spacing(4),
          alignItems: 'center',
          gap: theme.spacing(4),
        }}
      >
        <Icon
          id="export-datagrid-data"
          icon="download"
          sx={{ cursor: 'pointer' }}
          onClick={handleExport}
        />
      </Box>
    </GridToolbarContainer>
  );
};
